module.exports = __webpack_public_path__ + "ddfe6ef109a7a4443723870e6da227eb.svg";